export const PlatformSectionContents = [
  {
    title: "Ask Question",
    text: "Harness the power of human language to navigate your data. With Rose AI's advanced NLP and LLMs, you can effortlessly pose questions as naturally as you think them, ensuring precise and relevant results every time.",
  },
  {
    title: "Analyze & Visualize Data",
    text: "Transform raw data into compelling narratives. With Rose AI's dynamic visualization tools, every data point becomes a chapter in your story, making complex data landscapes easily navigable and comprehensible.",
  },
  {
    title: "Audit Logic",
    text: "Every insight is backed by a clear trail. With Rose AI, every data point, every visualization, and every answer is traceable, ensuring you always understand the 'why' behind your insights, fostering trust and reliability in your data journey.",
  },
];
